// app/components/GoogleAnalytics.tsx
import { useEffect } from "react";
import { useLocation } from "react-router";

const GA_TRACKING_ID = "G-4SPV9PH675"; // replace with your ID

export default function GoogleAnalytics() {
  const location = useLocation();

  // Don’t render anything in dev
  if (!import.meta.env.PROD) {
    return null;
  }

  // fire pageview on route changes
  useEffect(() => {
    if (!window.gtag) return;
    window.gtag("config", GA_TRACKING_ID, {
      page_path: location.pathname + location.search,
    });
  }, [location]);

  return (
    <>
      {/* Global site tag (gtag.js) - Google Analytics */}
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`}
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${GA_TRACKING_ID}', { send_page_view: false });
          `,
        }}
      />
    </>
  );
}
